module.exports = {"email":"E-mail","password":"Wachtwoord","login":"Inloggen"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/login.json
// module id = r8LW
// module chunks = 15